// @flow
import React from 'react'
import ReactDOM from 'react-dom'
import {observer} from 'mobx-react'
import {type Props} from '~/components/forms/input_wrapper'
import type {InputParam} from '~/flowtyped/stores/forms/form_builder_store_types'

/*
 * テキスト
 * */
@observer
class InputText extends React.Component<Props<string, InputParam>> {

  onChange = (e: SyntheticInputEvent<HTMLInputElement>): void => {
    const {store} = this.props
    store.setValue(e.target.value)
  }

  onFocus = (): void => {
    const {store} = this.props
    store.uncheck()
  }

  onBlur = (): void => {
    const {store} = this.props
    store.validate()
    store.handleBlur()
  }

  render() {
    const {store} = this.props
    return (
      <input
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        type="text"
        disabled={store.disabled}
        value={store.getValue()}
        name={store.getName()}
        maxLength={store.maxlength}
        placeholder={store.placeholder}
        className="wide input"
        id={store.idForLabel()} />
    )
  }
}
export default InputText
